<template>
  <p v-if="use_bool_value">
    <bool-icon v-if="value"></bool-icon>
  </p>
  <p v-else>
    {{ value }}
  </p>
</template>

<script>
import QualityAttributeMixin from "@/components/views/mixins/models/quality_attribute.js";
import BoolIcon from "@/components/views/layout/quality_control/BoolIcon.vue";

export default {
  mixins: [QualityAttributeMixin],
  components: { BoolIcon },
  props: {
    quality_general: { type: Object, required: true },
    quality_template: { type: Object, required: true },
  },
  computed: {
    value: function () {
      if (this.use_bool_value) return this.quality_general?.value_bool;
      return this.quality_general?.value;
    },
    use_bool_value: function () {
      const quality_attribute = this.quality_general?.quality_attribute;
      if (quality_attribute && this.quality_template)
        return (
          this.qualityAttributeIsBoolean(quality_attribute) &&
          !this.quality_template.use_samplings
        );
      return false;
    },
  },
};
</script>